import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70636a2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-mt-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cutom-margin-bottom" }, null, -1))
const _hoisted_4 = { class: "p-mt-3 footer-9 p-px-2 shadow-lg" }
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-jc-between p-my-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ค่าจัดส่ง", -1))
const _hoisted_7 = { class: "p-d-flex p-jc-between p-my-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionHeader = _resolveComponent("TransactionHeader")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_AddressDetailPanel = _resolveComponent("AddressDetailPanel")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalAlertError = _resolveComponent("ModalAlertError")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.transaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_TransactionHeader, {
            transactionInvoice: _ctx.transaction.invoiceNo,
            statusId: _ctx.transaction.statusId.toString(),
            statusName: _ctx.transaction.statusName,
            tittle: 'หมายเลขคำสั่งซื้อ',
            isDisplayInvoice: true
          }, null, 8, ["transactionInvoice", "statusId", "statusName"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionCartDetail, {
        transaction: _ctx.transaction,
        isShowCart: true,
        ref: "transactionCartDetailPanel"
      }, null, 8, ["transaction"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, {
        header: "ข้อมูลลูกค้า",
        toggleable: true,
        collapsed: _ctx.isCollapsed,
        "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCollapsed) = $event))
      }, {
        icons: _withCtx(() => [
          _createElementVNode("span", {
            class: "text-gray-1 f-size-14",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
          }, "ดูรายละเอียด")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AddressDetailPanel, {
            v: _ctx.v$.transaction.buyerInfo,
            transaction: _ctx.transaction,
            sessionId: _ctx.sessionId,
            isSelfPickup: _ctx.isSelfPickup,
            selfPickupAddress: _ctx.selfPickupAddress,
            vSelfPickupAddress: _ctx.v$.selfPickupAddress,
            onOnSetSelfPick: _ctx.onSetSelfPick,
            onOnSetSelfPickAddress: _ctx.onSetSelfPickAddress,
            onOnCalculateShippingCost: _ctx.onCalculateShippingCost,
            onSetSelfPickupAddress: _ctx.setSelfPickupAddress,
            ref: "addressDetailPanel"
          }, null, 8, ["v", "transaction", "sessionId", "isSelfPickup", "selfPickupAddress", "vSelfPickupAddress", "onOnSetSelfPick", "onOnSetSelfPickAddress", "onOnCalculateShippingCost", "onSetSelfPickupAddress"])
        ]),
        _: 1
      }, 8, ["collapsed"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.sessionId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.shippingCost)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
      ]),
      _createVNode(_component_Button, {
        class: "bg-black w-100",
        label: "ต่อไป",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBeforeSave()))
      })
    ]),
    _createVNode(_component_ModalAlertError, {
      modalMessage: _ctx.modalMessage,
      onOnHideModalError: _ctx.onHideModalError,
      ref: "modalAlertError"
    }, null, 8, ["modalMessage", "onOnHideModalError"])
  ]))
}